import React, { useState } from 'react'

import classes from './counter.module.scss'

import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { InView } from "react-intersection-observer";

Chart.register(CategoryScale);
Chart.register(ChartDataLabels);


export const Counter = () => {
  const isMobile = () => window.matchMedia && window.matchMedia("(max-width: 480px)").matches;
  const isTablet = () => window.matchMedia && window.matchMedia("(max-width: 1170px)").matches;
  //console.log(isMobile());
  const [dataIndex, setDataIndex] = useState(0);
  const [scrollMode, setScrollMode] = useState(0);
  const [farmerData, setFarmerData] = useState([
    0, 259, 588, 911, 1182, 1505, 1934, 2313, 2670, 3091, 3454, 3720
  ]);
  const [businessData, setBusinessData] = useState([
    0, 215, 419, 632, 868, 1025, 1236, 1458, 1645, 1951, 2162, 2417
  ]);  
  const [landGrabbersData, setLandGrabbersData] = useState([
    0, 149, 261, 366, 476, 588, 712, 879, 1018, 1201, 1369, 1531
  ]);
  const [governmentData, setGovernmentData] = useState([
    0, 55, 106, 153, 187, 216, 272, 328, 434, 537, 1056, 1187
  ]); 
  const [loggersData, setLoggersData] = useState([
    0, 38, 77, 111, 142, 194, 273, 328, 391, 449, 499, 570
  ]);
  const [miningData, setMiningData] = useState([
    0, 39, 75, 98, 135, 185, 265, 320, 368, 417, 458, 505
  ]);
  const [deforestation, setDeforestation] = useState([
    0, 392200, 396771, 402662, 407674, 413881, 421774, 428721, 436257, 446386, 457237, 470237
  ]);
  const [landconflict, setLandConflict] = useState([
    0, 755, 1526, 2271, 2990, 3713, 4692, 5626, 6526, 7646, 8998, 9930
  ]);

/*  const yearContent = [
    '',
    'In the early morning of 18 November 2011, some 40 gunmen arrived at a Guarani-Kaiowá indigenous encampment in Mato Grosso do Sul State, and shot tribal leader Nísio Gomes before dragging him away. Gomes’ body and three indigenous children abducted during the attack have not been seen since. A private security company, Gaspem Segurança, was implicated in the death of Gomes and another indigenous leader, Dorvalino Rocha. The same organization was found to have been responsible for burning indigenous houses, and kidnapping and beating indigenous people from 2009 to 2011.',
    'On 11 August 2012, federal police and agents of IBAMA and FUNAI seized 16 wood-hauling trucks from loggers in Caru Indigenous Territory in Maranhão. To leave the territory, the agents driving the confiscated trucks had to cross a bridge. As they approached, they saw that the bridge was engulfed in flames. A mob was milling around on the other side, and the agents could see that some people in the mob were armed. Outnumbered and unable to cross, the agents returned the vehicles to the loggers. 2012 marked a stark rise in deforestation which steadily is on the rise up until 2022. Brazil managed to keep these rates on decline for almost a decade prior to 2012.',
    'Rural producers in the state of Mato Grosso do Sul held an event to raise money to fight against Indigenous land claims. Known as the ‘Leilao da Resistencia’ (‘Resistance Auction’), the event raised some 640,000 Brazilian Reais by selling cattle and grain. According to the organizer, Francisco Maia, president of the State Breeders Association (Acrissul), the objective of the event was to fight against Indigenous land claims by funding mobilization actions, logistics, attorneys’ fees, publicity, and security.',
    'In October 2014, 14 ICMBio and military police agents found three logging trucks inside the Gurupi Biological Reserve in Maranhão. The owner tried to bribe the agents to release the trucks. The military police arrested him. Shortly after, several hundred men armed with guns, machetes, and stones surrounded the agents, who handed the trucks back and released the owner.',
    'Maria das Dores dos Santos Salvador, a rural community leader in Amazonas, was kidnapped and brutally killed on 12 August 2015. She had strongly denounced the illegal sale of community land and had faced threats for several years without receiving the necessary state protection.',
    'Global Witness reported that in 2016 the ‘ruthless scramble for the Amazon’s natural wealth makes Brazil, once again, the world’s deadliest country in terms of sheer numbers killed, 49, roughly one-third indigenous. The logging industry was linked to 16 murders, while landowners were the suspected perpetrators of many killings in the Amazon. Loggers also killed state agents defending the forest. IBAMA agents, with support from military police officers led by sergeant João Luiz de Maria Pereira, confiscated equipment from loggers in the Jamanxim National Forest in the state of Pará. The next day, Pereira was shot and killed while chasing one of the alleged loggers.',
    '2017 was the deadliest year related to land conflict in the Amazon, 71 murders in total, these includes: Pau D’Arco massacre of 10 landless workers, massacre of nine people in a settlement in Taquaruçu do Norte in the Colniza municipality of Mato Grosso State by  group of killers-for-hire including a former military police office, and a massacred more than ten members of an uncontacted tribe including women and children by illegal goldminers near Jandiatuba River, State of Amazonas.',
    'Osvalinda Marcelino Alves Pereira, and her husband, Daniel Alves Pereira, both small farmers in the settlement, became targets of intimidation and death threats by fazendeiros involved in illegal logging since 2011 when Osvalinda founded the Areia II Women’s Association to reforest land and for developing sustainable agricultural practices in the Areia Settlement Project in Pará. One morning in May 2018, the Pereiras awoke to find that someone had crept into their backyard during the night, piled up two mounds of soil, and erected crosses on top, simulating graves. Just in Para state in 2018,  there were 16 murders related to reporting illegal logging and other land conflicts.',
    '2019 was the year of the highest number of land conflicts in the Amazon in this 10 year period, just a year after Bolsonaro took office. On 1 November 2019, two members of a 120-member volunteer group from the Guajarara People known as the ‘Guardians of the Forest’, leader Paulo Paulino Guajajara was killed. A few weeks later, on 7 December 2019, an unidentified gunman shot and killed two Indigenous leaders, Firmino Prexede Guajajara and Raimundo Guajarara. The victims were coming back from a meeting with FUNAI, where they had been advocating in defense of their rights. Indigenous leaders of Guajajara villages and other guardians also reported death threats.',
    'Between March and May 2020, President Bolsonaro’s government passed 159 acts which critics say undermined environmental protection. Environmental minister Ricardo Salles in a meeting with President Bolsonaro and other ministers, proposed to use COVID pandemic that killed record numbers of Brazilians to deregulate and undermine environmental protection laws: We need to make an effort while we are at this moment of tranquility in the aspect of press coverage because [they] only talk about COVID, and run the cattle herd and change all the rules and simplify norms. Now is the time to join efforts to make deregulatory simplification in large numbers… Human Rights Watch (‘HRW’) claimed that ‘[criminal] groups involved in illegal deforestation have taken President Bolsonaro’s statements and policies weakening environmental law enforcement as a green light to destroy the forest and attack forest defenders.',
    'While a delegation of environmental defenders was attending COP 26 in Glasgow, a violent attack was committed by a group of armed men on an 80-person camp near São Vinicius Pará State.  Claudelice Silva dos Santos, prominent environmental defender who was at the COP26 told the Guardian newspaper: “For more than 10 years, these workers have been there, resisting for their land rights and … ranchers simply arrive here and want to kill everyone.”'
  ];*/
  // Portuguese version
  const yearContent = [
    '',
    'Na madrugada de 18 de novembro de 2011, cerca de 40 pistoleiros chegaram a um acampamento indígena Guarani-Kaiowá no Estado do Mato Grosso do Sul e atiraram no líder tribal Nísio Gomes antes de arrastá-lo. O corpo de Gomes e três crianças indígenas raptadas durante o ataque não foram vistos desde então. Uma empresa privada de segurança, Gaspem Segurança, foi implicada na morte de Gomes e de outro líder indígena, Dorvalino Rocha. A mesma organização foi considerada responsável pela queima de casas indígenas e sequestro e espancamento de indígenas de 2009 a 2011.',
    'Em 11 de agosto de 2012, a polícia federal e agentes do IBAMA e da FUNAI apreenderam 16 caminhões madeireiros na Terra Indígena Caru, no Maranhão. Para deixar o território, os agentes que conduziam os caminhões confiscados tiveram que atravessar uma ponte. Ao se aproximarem, viram que a ponte estava envolta em chamas. Uma turba se concentrava do outro lado, e os agentes puderam ver que algumas pessoas estavam armadas. Em menor número e incapazes de atravessar, os agentes devolveram os veículos aos madeireiros. O ano de 2012 marcou um aumento acentuado do desmatamento, que segue em constante crescimento até 2022. O Brasil conseguiu manter estas taxas em declínio por quase uma década antes de 2012.',
    'Os produtores rurais do estado de Mato Grosso do Sul realizaram um evento para arrecadar dinheiro para lutar contra as reivindicações de terras indígenas. Conhecido como "Leilão da Resistência", o evento arrecadou cerca de 640.000 reais através da venda de gado e grãos. Segundo o organizador, Francisco Maia, presidente da Associação dos Criadores do Estado (Acrissul), o objetivo do evento era combater as reivindicações de terras indígenas através de ações de mobilização de recursos, logística, honorários advocatícios, publicidade e segurança.',
    'Em outubro de 2014, 14 agentes do ICMBio e da polícia militar encontraram três caminhões madeireiros dentro da Reserva Biológica do Gurupi no Maranhão. O proprietário tentou subornar os agentes para liberar os caminhões. A polícia militar o prendeu. Pouco tempo depois, várias centenas de homens munidos de armas de fogo, facões e pedras cercaram os policiais, que entregaram os caminhões de volta e libertaram o proprietário.',
    'Maria das Dores dos Santos Salvador, uma líder comunitária rural no Amazonas, foi sequestrada e brutalmente assassinada em 12 de agosto de 2015. Ela havia denunciado veementemente a venda ilegal de terras comunitárias e enfrentou ameaças durante vários anos sem receber a proteção estatal necessária.',
    'A Global Witness relatou que em 2016 a "luta implacável pela riqueza natural da Amazônia faz do Brasil, mais uma vez, o país mais mortífero do mundo em número de mortos, 49, cerca de um terço de indígenas". A indústria madeireira estava ligada a 16 assassinatos, enquanto os proprietários de terras eram os suspeitos de muitos assassinatos na Amazônia. Os madeireiros também mataram agentes estatais que defendiam a floresta. Agentes do Ibama, com apoio de policiais militares liderados pelo sargento João Luiz de Maria Pereira, confiscaram equipamentos dos madeireiros da Floresta Nacional Jamanxim, no estado do Pará. No dia seguinte, Pereira foi baleado e morto enquanto perseguia um dos supostos madeireiros.',
    "2017 foi o ano mais mortífero com relação a conflitos de terras na Amazônia, com 71 assassinatos no total, incluindo: Massacre de Pau D'Arco de 10 trabalhadores sem terra, massacre de nove pessoas em um assentamento em Taquaruçu do Norte, no município de Colniza, no estado de Mato Grosso, por um grupo de assassinos contratados, incluindo policiais militares, e um massacre de mais de dez membros de uma tribo não contatada, incluindo mulheres e crianças, por garimpeiros ilegais perto do rio Jandiatuba, estado do Amazonas.",
    'Osvalinda Marcelino Alves Pereira, e seu marido, Daniel Alves Pereira, ambos pequenos agricultores do assentamento, tornaram-se alvos de intimidação e ameaças de morte por parte dos fazendeiros envolvidos em desmatamento ilegal desde 2011, quando Osvalinda fundou a Associação de Mulheres Areia II para reflorestar a terra e desenvolver práticas agrícolas sustentáveis no Projeto do Assentamento Areia no Pará. Em uma manhã de maio de 2018, as Pereiras acordaram para descobrir que alguém havia entrado no quintal delas durante a noite, empilhado dois montes de terra e erguido cruzes no topo, simulando sepulturas. Somente no estado do Pará, em 2018, houve X assassinatos relacionados à denúncia de desmatamento ilegal e outros conflitos por terra.',
    '2019 foi o ano do maior número de conflitos de terra na Amazônia neste período de 10 anos, um ano após a tomada de posse de Bolsonaro. Em 1º de novembro de 2019, dois membros de um grupo voluntário de 120 membros do Povo Guajarara, conhecido como "Guardiões da Floresta", o líder Paulo Paulino Guajajara foi morto. Poucas semanas depois, em 7 de dezembro de 2019, um pistoleiro não identificado atirou e matou dois líderes indígenas, Firmino Prexede Guajajara e Raimundo Guajajara. As vítimas estavam voltando de uma reunião com a FUNAI, onde defendiam seus direitos. Os líderes indígenas das aldeias Guajajara e outros guardiões também relataram ameaças de morte.',
    "Entre março e maio de 2020, o governo do Presidente Bolsonaro aprovou 159 atos que, segundo os críticos, prejudicaram a proteção ambiental. O Ministro do Meio Ambiente Ricardo Salles, em reunião com o Presidente Bolsonaro e outros ministros, propôs o uso da pandemia da COVID que matou um número recorde de brasileiros para desregulamentar e desmontar as leis de proteção ambiental: Precisamos fazer um esforço enquanto estamos neste momento de tranquilidade no aspecto da cobertura da imprensa porque [eles] só falam sobre a COVID, e dirigem o rebanho bovino e mudam todas as regras e simplificam as normas. Agora é o momento de unir esforços para fazer uma simplificação desregulamentadora em grande número. A Human Rights Watch ('HRW') alegou que '[grupos criminosos] envolvidos no desmatamento ilegal consideraram as declarações e políticas do Presidente Bolsonaro, enfraquecendo a aplicação da lei ambiental, como luz verde para destruir a floresta e atacar os defensores da floresta'.",
    'Enquanto uma delegação de defensores ambientais participava da COP 26 em Glasgow, um ataque violento foi cometido por um grupo de homens armados em um acampamento de 80 pessoas perto do estado de São Vinicius Pará.  Claudelice Silva dos Santos, importante defensora ambiental que estava na COP 26, disse ao jornal Guardian: "Há mais de 10 anos, estes trabalhadores estão lá, resistindo por seus direitos de terra e ... os fazendeiros simplesmente chegam aqui e querem matar todos".'
  ];

  const imageSrc = [
    '',
    'assets/2011.jpg',
    'assets/2012.jpg',
    'assets/2013.jpg',
    'assets/2014.jpg',
    'assets/2015.jpg',
    'assets/2016.jpg',
    'assets/2017.jpg',
    'assets/2018.jpg',
    'assets/2019.jpg',
    'assets/2020.jpg',
    'assets/2021.jpg',
  ]

  const dataSet = (data: any) => {
    if (scrollMode === 0 || scrollMode === 2)
      return data.slice(0, dataIndex + 1);
    else if (scrollMode === 1)
      return data.slice(0, dataIndex + 2);
  };

  const data = {
    labels: [
      "",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
    ],
    datasets: [
      {
        data: dataSet(miningData),
        label: "Mining",
        borderColor: "#993939",
        backgroundColor: "rgba(153,57,57, 0.8)",
        fill: true,
        borderWidth: 2,
        lineTension: 0.2,
      },
      {
        data: dataSet(loggersData),
        label: "Loggers",
        borderColor: "#B04343",
        backgroundColor: "rgba(176,67,67, 0.8)",
        fill: true,
        borderWidth: 2,
        lineTension: 0.2,
      },
      {
        data: dataSet(governmentData),
        label: "Government",
        borderColor: "#BD5F5F",
        backgroundColor: "rgb(189,95,95,0.8)",
        fill: true,
        borderWidth: 2,
        lineTension: 0.2,
      },
      {
        data: dataSet(landGrabbersData),
        label: "Land-grabbers",
        borderColor: "#C77070",
        backgroundColor: "rgb(199,112,112,0.8)",
        fill: true,
        borderWidth: 2,
        lineTension: 0.2,
      },
      {
        data: dataSet(businessData),
        label: "Business",
        borderColor: "#D69494",
        backgroundColor: "rgba(214,148,148, 0.8)",
        fill: true,
        borderWidth: 2,
        lineTension: 0.2,
      },
      {
        data: dataSet(farmerData),
        label: "Farmers",
        borderColor: "#F3CDCD",
        backgroundColor: "rgba(243,205,205, 0.8)",
        fill: true,
        borderWidth: 2,
        lineTension: 0.2,
      },
    ],
  };

  return (
    <main className={classes.layout}>
      <div className={classes.grid}>
        <aside className={classes.aside}>
          {data.labels.map((label, key) => {
            return key > 0 && (
              <InView
                as="div"
                threshold={0.2}
                className={label}
                key={key}
                onChange={(inView, entry) => {
                  if (inView) {
                    if (dataIndex < key) setScrollMode(0);
                    if (dataIndex > key) setScrollMode(1);
                    setDataIndex(key);
                  }
                }}
              >
          <div className={classes.year}>
            <div className={classes.year__date}>{label}</div>
            <div className={classes.year__content}>
              {
                imageSrc[key] &&
                <img src={imageSrc[key]} alt="" width="100%" />
              }
              <p className={classes['margin-text']}>
                {yearContent[key]}
              </p>
            </div>
          </div>
                </InView>
            );
          })}
        </aside>

        <section className={classes.chart}>
          <div className={classes['chart-header']}>
            <div className={classes['chart-header__left']}>
              {/*<span>Deforestation Cumulative</span>*/}
              <span>Desmatamento Acumulado</span>
              <span>{deforestation[dataIndex].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} km&#178;</span>
            </div>
            <div className={classes['chart-header__right']}>
              {/*<span>Land conflict Cumulative</span>*/}
              <span>Conflitos no Campo Acumulado</span>
              <span>{landconflict[dataIndex].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
            </div>
          </div>
          <div>
            <Line options={{
              responsive: true,
              elements: {
                point: {
                  radius: 0,
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  max: 3800,
                  min: 0,
                  ticks: {
                    stepSize: 200,
                    font: {
                      family:'Roboto Condensed',
                      size: isMobile()?7:14,                    
                    }
                  }
                },
                x: {
                  max:"2022",
                  grid: {
                    display: false
                  },
                  ticks: {
                    font: {
                      family:'Roboto Condensed',
                      size: isMobile()?7:16,
                      weight: "bold"
                    }
                  }
                },              
              },
              plugins: {
                // Change options for ALL labels of THIS CHART
                datalabels: {
                  font: {
                    family:'Roboto Condensed',
                    size: 14,                    
                  },
                  color: "#8e9490",
                  anchor: "end",
                  align: "end",
                  display: function (context: any) {              
                    if (scrollMode === 0 || scrollMode === 2)
                      return context.dataIndex === dataIndex && context.datasetIndex>5;
                    else
                      return context.dataIndex === dataIndex + 1 && context.datasetIndex>5;
                  },
                },
                legend: {
                  display: false
                },
                tooltip: {
                  enabled: false,     
                  callbacks: {
                    label: (context) => context.parsed.y +' '+context.dataset.label,
                    title: () => {},
                  },
                  itemSort: (a, b)=> b.datasetIndex - a.datasetIndex,
                  backgroundColor:'transparent',                
                  bodyColor:'#000000',
                  displayColors: false,
                },
              },
              interaction: {
                mode: 'nearest',
                axis: 'x',
                intersect: false
              },
              animations: {
                y: {
                  type: 'number',
                  duration: scrollMode === 2 ? 0 : 1500,
                  easing: 'linear',
                  loop: false,
                  from: function (ctx: any) {
                    if (scrollMode === 0)
                      return ctx.index === 0 ? ctx.chart.scales.y.getPixelForValue(0) : ctx.chart.scales.y.getPixelForValue(ctx.dataset.data[ctx.index - 1]);
                    else if (scrollMode === 1) return ctx.chart.scales.y.getPixelForValue(ctx.dataset.data[ctx.index]);
                  },
                  to: function (ctx: any) {
                    if (scrollMode === 0)  
                      return ctx.chart.scales.y.getPixelForValue(ctx.dataset.data[ctx.index]);
                    else if (scrollMode === 1)
                      return ctx.index === 0 ? ctx.chart.scales.y.getPixelForValue(0) : ctx.chart.scales.y.getPixelForValue(ctx.dataset.data[ctx.index - 1]);
                    //return 436.6;
                  }
                },
                x: {
                  type: 'number',
                  duration: scrollMode === 2 ? 0 : 1500,
                  easing: 'linear',
                  loop: false,
                  from: function (ctx: any) {
                    if (scrollMode === 0)
                      return ctx.index === 0 ? ctx.chart.scales.x.getPixelForValue(0) : ctx.chart.scales.x.getPixelForValue(ctx.index - 1);
                    else if (scrollMode === 1)
                      return ctx.chart.scales.x.getPixelForValue(ctx.index);
                  },
                  to: function (ctx: any) {
                    if (scrollMode === 0)
                      return ctx.chart.scales.x.getPixelForValue(ctx.index);
                    else if (scrollMode === 1)
                      return ctx.index === 0 ? ctx.chart.scales.x.getPixelForValue(0) : ctx.chart.scales.x.getPixelForValue(ctx.index - 1);
                  },
                },              
              },
              animation: {
                onComplete: function() {
                  setScrollMode(2);                  
                },
                onProgress:(animation)=>{
                  var offsetY=isTablet()?-7:38;
                  var fontSize=isMobile()?7:14;  
                  var farmersEl=animation.chart.$datalabels._labels[0]._el;
                  var farmersValues=dataSet(farmerData);
                  //document.getElementById("farmers").innerHTML=farmersValues[farmersValues.length-1]+' Farmers';                  
                  document.getElementById("farmers").innerHTML=farmersValues[farmersValues.length-1]+' Fazendeiro ';
                  document.getElementById("farmers").style.left=farmersEl.x+'px';
                  document.getElementById("farmers").style.top=farmersEl.y+offsetY+'px';

                  var businessEl=animation.chart.$datalabels._labels[1]._el;
                  var businessValues=dataSet(businessData);
                  //document.getElementById("business").innerHTML=businessValues[businessValues.length-1]+' Entrepreneurs';
                  document.getElementById("business").innerHTML=businessValues[businessValues.length-1]+' Empresário';
                  document.getElementById("business").style.left=businessEl.x+'px';
                  document.getElementById("business").style.top=businessEl.y+offsetY+'px';

                  var landGrabbersEl=animation.chart.$datalabels._labels[2]._el;
                  var landGrabbersValues=dataSet(landGrabbersData);
                  //document.getElementById("landGrabbers").innerHTML=landGrabbersValues[landGrabbersValues.length-1]+' Land-grabbers';
                  document.getElementById("landGrabbers").innerHTML=landGrabbersValues[landGrabbersValues.length-1]+' Grileiro';
                  document.getElementById("landGrabbers").style.left=landGrabbersEl.x+'px';
                  document.getElementById("landGrabbers").style.top=landGrabbersEl.y+offsetY+'px';

                  var governmentEl=animation.chart.$datalabels._labels[3]._el;
                  var governmentValues=dataSet(governmentData);
                  //document.getElementById("government").innerHTML=governmentValues[governmentValues.length-1]+' State';
                  document.getElementById("government").innerHTML=governmentValues[governmentValues.length-1]+' Estado';
                  document.getElementById("government").style.left=governmentEl.x+'px';
                  document.getElementById("government").style.top=governmentEl.y+offsetY+'px';

                  var loggersEl=animation.chart.$datalabels._labels[4]._el;
                  var loggersValues=dataSet(loggersData);
                  //document.getElementById("loggers").innerHTML=loggersValues[loggersValues.length-1]+' Loggers';
                  document.getElementById("loggers").innerHTML=loggersValues[loggersValues.length-1]+' Madeireiro ';
                  document.getElementById("loggers").style.left=loggersEl.x+'px';
                  document.getElementById("loggers").style.top=loggersEl.y+(offsetY+fontSize)+'px';

                  var miningEl=animation.chart.$datalabels._labels[5]._el;
                  var miningValues=dataSet(miningData);
                  //document.getElementById("mining").innerHTML=miningValues[miningValues.length-1]+' Mining companies';
                  document.getElementById("mining").innerHTML=miningValues[miningValues.length-1]+' Mineradora';
                  document.getElementById("mining").style.left=miningEl.x+'px';
                  document.getElementById("mining").style.top=miningEl.y+(offsetY+fontSize*2)+'px';
                }
              }
            }} data={data} height="180"/>
            <div id="farmers" className={classes.tooltip}></div>
            <div id="business" className={classes.tooltip}></div>
            <div id="landGrabbers" className={classes.tooltip}></div>
            <div id="government" className={classes.tooltip}></div>
            <div id="loggers" className={classes.tooltip}></div>
            <div id="mining" className={classes.tooltip}></div>
          </div>
        </section>
      </div>
    </main>
  )
}
